// @ts-nocheck
import React from 'react';
import Chip from '@mui/material/Chip';
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export default function InternosReduced({ internos }) {
    const internosArray = internos.map(interno => interno.split(';'));

    return (
        <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
            <Typography variant='body1' color="secondary" sx={{ whiteSpace: 'nowrap' }}>
                Internos:
            </Typography>
            {internosArray.length === 0 ? (
                <Chip size="small" label="No hay internos registrados" />
            ) : (
                internosArray.map((interno, index) => (
                    <Chip key={index} color="primary" size="small" label={`${interno[0].substr(7)} - ${interno[1].substr(15)}`} />
                ))
            )}
        </Box>
    );
}